import { Box, Callout, Flex, Grid, Heading, Spinner, Text } from '@radix-ui/themes';
import { useCurrentPrices } from '@/hooks/usePrices';
import { PriceCard } from '@/components/PriceCard';

export function Home() {
  const { data: prices, loading, error } = useCurrentPrices();

  return (
    <Box px="4">
      <Flex direction="column" gap="4" mb="6">
        <Heading size="7">Aktuella elpriser</Heading>
        <Text color="gray" size="2">
          Klicka på ett område för att se dagens kompletta prisbild
        </Text>
      </Flex>

      {loading && (
        <Flex justify="center" py="9">
          <Spinner size="3" />
        </Flex>
      )}

      {error && (
        <Callout.Root color="red">
          <Callout.Text>{error.error || 'Kunde inte hämta priser'}</Callout.Text>
        </Callout.Root>
      )}

      {prices && (
        <Grid columns={{ initial: '1', sm: '2' }} gap="4">
          {prices.map((price) => (
            <PriceCard key={price.area} price={price} />
          ))}
        </Grid>
      )}
    </Box>
  );
}
